import { Link } from 'react-router-dom';
import BadgeEspace from './BadgeEspace';
import BadgeGratuite from './BadgeGratuite';
import BadgeReset from './BadgeReset';
import BadgeParrainage from './BadgeParrainage';
import Logo from './Logo';
import ThemeToggle from './ThemeToggle';

/**
 * En-tête mobile : le logo à gauche, et à droite une colonne — le choix de
 * thème au-dessus, l'appel à parrainage dessous.
 *
 * Plus de badge de rôle ici : il disait à tout regard par-dessus l'épaule la
 * fonction du porteur du téléphone, sans rien offrir que Mon espace ne donne
 * déjà.
 */
export default function Header() {
  return (
    <header className="sticky top-0 z-50 bg-white/90 dark:bg-gray-900/90 backdrop-blur border-b border-gray-100 dark:border-gray-800 px-4 py-2.5">
      <div className="flex items-center justify-between">
        <div className="min-w-0">
          <Link to="/" className="text-primary-700 block">
            <Logo size="sm" />
          </Link>
          {/* La période offerte, sous le nom de l'association. */}
          <span className="flex flex-wrap items-center gap-1.5 mt-1">
          <BadgeGratuite />
          <BadgeReset />
          <BadgeEspace />
          <BadgeParrainage />
        </span>
        </div>

        <div className="flex flex-col items-end gap-1.5">
          <ThemeToggle />
          <Link
            to="/sponsors"
            className="text-xs font-medium bg-primary-600 text-white px-3 py-1 rounded-full"
          >
            Devenir sponsor
          </Link>
        </div>
      </div>
    </header>
  );
}
